import { Canvas } from "@react-three/fiber";
import { Stars } from "@react-three/drei";

const Star = ({ count = 2000 }: { count?: number }) => {
  return (
    <div className="absolute inset-0 z-0">
      <Canvas>
        <Stars radius={50} count={count} factor={4} fade speed={2} />
      </Canvas>
    </div>
  );
};

export default Star;
